/** Native inputs that hold typed search text (not dates, checkboxes, hidden, etc.). */
export const SEARCH_TEXT_INPUT_SELECTOR = [
  'input[type="text"]',
  'input[type="search"]',
  'input:not([type])',
].join(', ');

export function trimInputElement(input: HTMLInputElement | HTMLTextAreaElement): boolean {
  const trimmed = (input.value || '').trim();
  if (input.value === trimmed) return false;
  input.value = trimmed;
  // Keep ngModel / FormControl in sync; DefaultValueAccessor listens to `input`.
  input.dispatchEvent(new Event('input', { bubbles: true }));
  return true;
}

export function trimSearchInputsIn(root: ParentNode | null | undefined): void {
  if (!root || typeof (root as ParentNode).querySelectorAll !== 'function') return;
  root.querySelectorAll(SEARCH_TEXT_INPUT_SELECTOR).forEach((el) => {
    const input = el as HTMLInputElement;
    if (input.disabled || input.readOnly) return;
    trimInputElement(input);
  });
}

export function isSearchForm(form: HTMLElement): boolean {
  if (form.classList.contains('header-search')) return true;
  if (form.querySelector('input[name="search"], input[name="query"], input[placeholder^="Search"]')) {
    return true;
  }
  return Array.from(form.querySelectorAll('button, a')).some((el) => isSearchSubmitControl(el as HTMLElement));
}

export function isSearchSubmitControl(el: HTMLElement): boolean {
  const label = (el.textContent || '').replace(/\s+/g, ' ').trim();
  if (/^search$/i.test(label)) return true;
  if (el.querySelector('.fa-search')) return true;
  return el.classList.contains('input-group-text') && !!el.querySelector('.fa-search');
}

/** Walk up from a Search button to the container that actually holds the fields. */
export function findSearchRoot(el: HTMLElement): ParentNode {
  const form = el.closest('form');
  if (form) return form;
  const modal = el.closest('bk-modal, .modal-content, .modal-body');
  if (modal) return modal;
  let node: HTMLElement | null = el.parentElement;
  while (node) {
    if (node.querySelector(SEARCH_TEXT_INPUT_SELECTOR)) return node;
    node = node.parentElement;
  }
  return el.parentElement || el;
}

export function trimStringFields<T extends Record<string, unknown>>(obj: T): T {
  const out = { ...obj };
  Object.keys(out).forEach((key) => {
    const value = out[key];
    if (typeof value === 'string') {
      (out as Record<string, unknown>)[key] = value.trim();
    }
  });
  return out;
}
